<template>
  <div>
    <el-button :type="btnType" size="medium" round @click="clickBtn" >{{btnContent}}</el-button>

    <!-- 弹框 -->
    <el-dialog :title="title"
               :visible="dialogVisible"
               :width="controlWidth"
               @close="onClose"
               :modal-append-to-body="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <div class="dialog-content" v-loading="loading">
        <!--价位选择-->
        <ul>
          <li v-for="(item,index) in moneyList" :key="index" @click="choose(item)" :class="item.active ? 'active' : ''">
            <p>
              <i class="el-icon-s-finance"></i>
              <b>{{item.money}}</b>
            </p>
            <span>￥{{ formatDecimal(item.money / (1 - ((PaymentType == 8 && PaymentTypeNew=='banks') ? 0 : fee))) }}</span>
          </li>
          <li @click="chooseLast()" :class="last.active ? 'active' : ''">
            <p>
              <i class="el-icon-s-finance"></i>
              <b><el-input type="text" v-model="last.money" style="width: 100px;"
                           oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"></el-input></b>
            </p>
            <span>￥{{ formatDecimal(last.money / (1 -((PaymentType == 8 && PaymentTypeNew=='banks') ? 0 : fee))) }}</span>
          </li>
        </ul>
        <div class="section">
          <span>应支付手续费：</span>
          <p style="color: #555; font-size: 18px">
            <span v-if="(PaymentType == 8 && PaymentTypeNew=='quick')" style="text-decoration: line-through; margin-right: 10px;"> ￥{{ formatDecimal(money / (1 - fee) - money)}} </span>
            ￥{{ (PaymentType == 8 && PaymentTypeNew=='banks') ? 0 : formatDecimal(money / (1 - fee) - money) }}</p>
        </div>
        <!--应付金额-->
        <div class="section">
          <span>应付总金额：</span>
          <p> <span v-if="(PaymentType == 8 && PaymentTypeNew=='quick')" style="text-decoration: line-through; margin-right: 10px;"> ￥{{ toFixed(money / (1 -fee)) }} </span> ￥{{ theMoney }}</p>
        </div>
        <!--支付方式-->
        <div class="section">
          <span>支付方式：</span>
          <el-radio-group v-model="PaymentTypeNew">
            <!--TOdO-->
            <!--<el-radio v-if="hasQuickFlag" label="quick" border size="mini">快捷支付</el-radio>-->
            <el-radio label="banks" border size="mini">网银支付</el-radio>
          </el-radio-group>
        </div>
        <div class="section" v-if="PaymentTypeNew == 'banks'">
          <ul class="clearfix banks-sty">
            <li v-for="(item,index) in banksChouse" :key="index" :class="item.Active ? 'active' : ''" @click="chooseBank(item)">
              <img v-if="item.HasPic" :src="item.ImgUrl" style="width: 98px;height: 48px;">
              <p style="position: absolute;font-size: 14px;line-height: 48px;margin: 0px auto;left: 0px;right: 0px;color: #000;" v-else>其他银行</p>
            </li>
          </ul>

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button v-if="PaymentTypeNew == 'banks'" type="success" @click="toPayBank(false)"> 立即支付 </el-button>
          <el-button v-else type="success" @click="toPayQuick(true)"> 立即支付 </el-button>
        </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="友情提示" :visible.sync="dialogFormVisible">
      <div class="account-list">
        <p style="font-size: 14px;font-weight: 600;margin-bottom: 15px;">请自行转到以下任意企业账户中：</p>
        <ul class="clearfix">
          <li style="width: 48%;margin-right: 10px;" v-for="(item,index) in companyAccount" :key="index">
            <!--<p><span>名称</span>：{{item.EnterpriseId}}</p>-->
            <p><span>账号</span>：{{item.Account}}</p>
            <p><span>开户行</span>：{{item.AccountBank}}</p>
          </li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import PayButton from '@/components/Buttons/PayButton'

  export default {
    components: {
      PayButton
    },
    props: {
      btnType: {
        type: String
      },
      btnContent: {
        type: String
      },
      title: {
        type: String
      },
      width: {
        type :String,
        default: '400px'
      },
      moneyList:{
        type: Array
      },
      selectMoney: {
        type: Number
      },
      accountType:{
        type: String
      },
      customId:{
        type: String,
        default:null
      },
    },
    data() {
      return {
        last: {
          active: false,
          money: 0,
          coolMoney: 0
        },
        banksChouse:[

        ],
        fee: 0,
        PaymentType: 8,
        PaymentTypeNew:'banks',
        dialogVisible:false,
        loading: false,
        money:10,
        url:{
          pay: SZH.assets.api + "/UnionPay/Pay",
          payOnline: SZH.assets.api + "/OnlinePay/Pay",
          getCardInfo: SZH.assets.api + "/Custom/GetCustomBankCardInfo",
          checkStatusUrl: SZH.assets.api + "/UnionPay/CheckOpenStatus",
          GetEnterprisePaymentInfo: SZH.assets.api + "/OnlinePay/GetEnterprisePaymentInfo",
          GetEnterprisePayCardInfo: SZH.assets.api + "/OnlinePay/GetEnterprisePayCardInfo",
        },
        infoMessage:'正在获取银行卡相关信息...',
        dialogFormVisible:false,
        companyAccount:[],
        PaymentBank:'',
        hasQuickFlag:false,
      }
    },
    methods: {
      onCannotpay() {
        this.loading = false;
      },
      beforePay() {
        this.loading = true;
      },
      toFixed(val) {
        return parseFloat(val).toFixed(2);
      },
      clickBtn(type){
        this.$confirm('您确定要'+this.title+'吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.$emit('clickBtn');
          var find = false;
          for(var i = 0;i<this.moneyList.length;i++){
            if(this.moneyList[i].active == true){
              this.money = this.moneyList[i].money;
              find = true;
              break;
            }
          }
          if(!find) {
            this.money = this.selectMoney;
            this.last.active = true;
            this.last.money = this.selectMoney;
          }
          this.dialogVisible = true;
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消充值'
          });
        });

      },
      onClose() {
        this.dialogVisible = false;
      },
      chooseLast() {
        if(!this.last.active) {
          for(var i in this.moneyList){
            this.moneyList[i].active = false;
          }
          this.last.active = true;
          this.money = this.last.money;
        }
      },
      choose(val){
        this.last.active = false;
        for(var i in this.moneyList){
          this.moneyList[i].active = false;
          if(this.moneyList[i].money == val.money){
            this.moneyList[i].active = true;
          }
        }
        this.money = val.money;
      },
      // 支付
      toPay(){
        this.$emit('toPay')
      },
      payAgain(){
        this.$refs['payButton'].pay();
      },
      formatDecimal(num) {
        num = num.toString();
        let index = num.indexOf('.');
        if (index !== -1) {
          num = num.substring(0, 2 + index + 1)
        } else {
          num = num.substring(0)
        }
        return parseFloat(num).toFixed(2)
      },
      //无跳转支付
      toPayNew(){
        let self =this;
        const loading = self.$loading({
          lock: true,
          text: self.infoMessage,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        self.$http.post(self.url.getCardInfo,{

        }).then(result =>{
          if(result.State == 1){
            // loading.close();
            self.infoMessage = '正在验证是否开通无跳转支付....';
            self.checkStatus(result.Data,loading);
          }else{

            loading.close();
          }
        }, () => {
          loading.close();
          self.$message.error('数据保存失败，请检查您的网络是否可用。');
        });
      },

      checkStatus(info,load){
        let self =this;
        self.$http.post(self.url.checkStatusUrl,{
          Data:{
            AccNo:info.Account
          }
        }).then(result =>{
          if(result.State == 1){
            self.$router.push({
              path:'/CheckToPay',
              query:{
                info:this.$Base64.encode(JSON.stringify({
                  AccNo: info.Account,
                  Phone:info.PhoneNumber,
                  moneyDad:info.Enterprise,
                  money:self.formatDecimal((this.money / (1 -this.fee)))
                }))
              }
            });
            load.close();
          }else if(result.State == 9){
            self.$notify.error({
              title: '错误',
              message: result.Message
            });
            load.close();
          }else{
            self.$router.push({
              path:'/CheckPay',
              query:{
                info:this.$Base64.encode(JSON.stringify({
                  AccNo: info.Account,Phone:info.PhoneNumber
                }))
              }
            });
          }
        }, () => {
          self.$message.error('数据保存失败，请检查您的网络是否可用。');
        });

      },
      chooseBank(val){
        if(val.Name != '其他银行'){
          for(var i in this.banksChouse){
            this.banksChouse[i].Active = false;
            if(this.banksChouse[i].Name == val.Name){
              this.banksChouse[i].Active = true;
              this.PaymentBank = val.Payment;
            }
          }
        }else{
          // this.$message.error('其他银行');
          this.dialogFormVisible = true;
          this.getEnterprisePaymentInfo();
        }

      },
      getEnterprisePaymentInfo(){
        let self =this;
        self.$http.post(self.url.GetEnterprisePaymentInfo,{

        }).then(result =>{
          if(result.state == true && result.data && result.data.length>0){
            self.companyAccount = result.data;
          }else{
            self.companyAccount = [];
          }
        }, () => {

        });
      },
      getBanks(){
        let self =this;
        self.$http.post(self.url.GetEnterprisePayCardInfo,{
        }).then(result =>{
          if(result.state == true && result.data && result.data.length>0){
            result.data.forEach(item=>{
              if(item.Payment == '8'){
                item.ImgUrl = '../../../static/images/logo/gsyhlogo.png';
                self.hasQuickFlag = true;
              }else if(item.Payment == '1'){
                item.ImgUrl = '../../../static/images/logo/nyyhlogo.png'
              }else if(item.Payment == '9'){
                item.ImgUrl = '../../../static/images/logo/jsyhlogo.png'
              }
            });
            let otherBank = {
              Name:'其他银行',
              Payment:99,
              Active:false,
              HasPic:false,
              ImgUrl:''
            };
            result.data.push(otherBank);
            self.banksChouse = result.data;
          }else{
            let arr = [];
            let otherBank = {
              Name:'其他银行',
              Payment:99,
              Active:false,
              HasPic:false,
              ImgUrl:''
            };
            arr.push(otherBank);
            self.banksChouse = arr;
          }
        }, () => {

        });
      },
      // 银行支付
      toPayBank(){
        let self =this;
        if(!self.PaymentBank){
          self.$message.error('请选择银行');
          return
        }
        const loading = self.$loading({
          lock: true,
          text: '充值中.....',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        self.$http.post(self.url.payOnline,{
          PayAmout: self.theMoney,
          PaymentType: self.PaymentBank,
          CustomType:self.accountType,
          MoneyType:'货款',
          Source:'油e购',
          IsQuickPayment:false,
          CustomId:self.customId
        }).then(result =>{
          if(result.state == true){
            // self.$message.success('充值成功');
            setTimeout(() => {
              var doc = window.document;
              let param = {
                data:result.data
              };
              window.sessionStorage.setItem("html",result.data);
              let routeData = self.$router.resolve({
                path: '/Pay',
                name: 'Pay',
                params: param
              });
              window.open(routeData.href, '_blank')
            }, 100);
          }else{
            self.$message.error(result.message);
            loading.close();
          }
          let obj={
            orderId:result.message,
            PaymentType:self.PaymentBank
          };
          self.$emit('onpay',obj);
          self.dialogVisible = false;
          loading.close();
        }, () => {
          loading.close();
          self.$message.error('数据保存失败，请检查您的网络是否可用。');
        });
      },
      toPayQuick(flag){
        let self =this;
        const loading = self.$loading({
          lock: true,
          text: '充值中.....',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        self.$http.post(self.url.payOnline,{
          Data:{
            PayAmout: self.theMoney,
            PaymentType: 8,
            CustomType:self.accountType,
            MoneyType:'货款',
            Source:'油e购',
            IsQuickPayment:flag,
            CustomId:self.customId
          }
        }).then(result =>{
          if(result.State == 1){
            // self.$message.success('充值成功');
            setTimeout(() => {
              var doc = window.document;
              let param = {
                data:result.Data
              };
              window.sessionStorage.setItem("html",result.Data);
              let routeData = self.$router.resolve({
                path: '/Pay',
                name: 'Pay',
                params: param
              });
              window.open(routeData.href, '_blank')
            }, 100);
          }else{
            self.$message.error(result.Message);
          }
          self.$emit('onpay',result.Message);
          self.dialogVisible = false;
          loading.close();
        }, () => {
          loading.close();
          self.$message.error('数据保存失败，请检查您的网络是否可用。');
        });
      }




    },
    mounted(){
      // this.bank = SZH.bank;
      // if(this.bank == 'abc') {
      //   this.PaymentType = 1;
      // }
      // else if(this.bank == 'nojumpunionpay') {
      //   this.PaymentType = 6;
      // }else{
      //   this.PaymentType = 0;
      // }
      // this.fee = SZH.bankfee;
      // console.log(this.accountType)
      this.getBanks();
    },
    computed: {
      controlWidth(){
        return this.width
      },
      theMoney() {
        return parseFloat(this.PaymentType == 8 ? this.formatDecimal((this.money / (1 -this.fee))): this.money)
      }
    },
    watch: {
      dialogVisible(val) {
        this.last = {
          active: false,
          money: 0,
          coolMoney: 0
        };
        if(!val) {
          for(var i in this.moneyList){
            this.moneyList[i].active = false;
          }
          this.moneyList[0].active = true;
          this.last = {
            active: false,
            money: 0,
            coolMoney: 0
          }
        }
      },
      'last.money'(val) {
        this.chooseLast();
        this.last.money = val;
        this.money = val;
      },
      'PaymentTypeNew'(val){
        this.paymentType = 8;
        if(val == 'quick'){
          this.fee = 0.0025
        }else{
          this.fee = 0
        }
      }
    }
  }
</script>

<style scoped>

  button{width: 100%;}
  .dialog-content{
    width: 100%;
  }
  .dialog-content ul{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -12px;
    justify-content: space-around;
  }
  .dialog-content ul li{
    width: 156px;
    height: 96px;
    margin-bottom: 12px;
    border: 1px solid #ddd;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
  }
  .dialog-content ul li.active{
    border: 2px solid #0a529c;
  }
  .dialog-content ul li.active span{
    color: #0a529c;
  }
  .dialog-content ul li p{
    font-size: 24px;
    height: 57px;
    line-height: 57px;
  }
  .dialog-content ul li p i{
    color: #0a529c;
  }
  .dialog-content ul li>span{
    background: #eeeeee;
    display: inline-block;
    width: 100%;
    height: 35px;
    line-height: 35px;
  }
  .dialog-content .section{
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  .dialog-content .section span{
    font-size: 14px;
    color: #999;
    line-height: 20px;
  }
  .dialog-content .section p{
    font-size: 24px;
    color: #ff4081;
    line-height: 20px;
  }
  .banks-sty{
    display: block !important;
  }
  .banks-sty li{
    position: relative;
  }
  .banks-sty li.active{
    border: 2px solid red !important;
  }
  .banks-sty li{
    list-style: none;
    display: inline-block;
    height: 50px !important;
    width: 108px !important;
    margin-bottom: 0px !important;
    margin-left: 10px !important;
  }
  .banks-sty li img{
    text-align: center;
  }
  .account-list ul li{
    display: inline-block;
    border-radius: 4px;
    border: 1px dashed #000;
    padding: 10px;
  }
  .account-list ul li p{
    margin-bottom: 15px;
  }
  .account-list ul li p:last-child{
    margin-bottom: 0px;
  }
  .account-list ul li p span{
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/DialogButton1.vue